// ABOUTME: The two time-based flows the runner frame owns and a screen's layer draws: the build-in and the send-off stage.
// ABOUTME: Published through one context so a screen reads them without the frame knowing what the screen draws.

import { createContext, useContext } from 'react';

// 0 = at rest; 1 to 3 are the beats of the send-off; 4 is the final fade to the overlay.
export type SendOffStage = 0 | 1 | 2 | 3 | 4;

export interface ScreenMotion {
  buildIn: boolean;
  sendOffStage: SendOffStage;
}

export const ScreenMotionContext = createContext<ScreenMotion>({ buildIn: false, sendOffStage: 0 });
export const useScreenMotion = () => useContext(ScreenMotionContext);
